import { render } from "./OtpVerify.vue?vue&type=template&id=b24683fc&scoped=true"
import script from "./OtpVerify.vue?vue&type=script&lang=js"
export * from "./OtpVerify.vue?vue&type=script&lang=js"

import "./OtpVerify.vue?vue&type=style&index=0&id=b24683fc&scoped=true&lang=css"
import "./OtpVerify.vue?vue&type=style&index=1&id=b24683fc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b24683fc"]])

export default __exports__